export default __webpack_public_path__ + "static/media/Icon - View holidays for entities.519b865d.svg";